module.exports = __webpack_public_path__ + "img/logo.dd3ce11e.png";